import { homeTasksContracts } from "./home-tasks.contract";

export const homeContracts = {
  tasks: homeTasksContracts,
} as const;

// Re-export types
export * from "./home-tasks.contract";
